<script setup lang="ts">
defineProps<{
    item: MenuItem
}>()

const emit = defineEmits<{
    (_event: 'close'): void
}>()

async function callItemAction(event: Event, item: MenuItem) {
    if (item.action) {
        await item.action(event)
    }

    emit('close')
}

const expanded = ref(false)

function onEnter(container: HTMLElement) {
    container.style.maxHeight = `${container.scrollHeight}px`
}

function onLeave(container: HTMLElement) {
    container.style.maxHeight = ''
}
</script>
    
<script lang="ts">
export default { name: 'MenuDialogItem' }
</script>
    
<template>
    <li v-if="item.items" class="list-none overflow-hidden">
        <button
            type="button"
            class="flex w-full items-center justify-between rounded border border-deep-blue px-2 py-2 text-sm"
            :class="{
                'rounded-b-none border-b-0': expanded
            }"
            @click="expanded = !expanded"
        >
            <span>
                {{ item.label }}
            </span>
            <ChevronDownIcon class="h-4" />
        </button>

        <Transition @leave="onLeave" @enter="onEnter">
            <ul
                v-if="expanded"
                class="flex max-h-0 flex-col gap-2 divide-y divide-neutral rounded rounded-t-none border border-t-0 border-deep-blue bg-white transition-[max-height] duration-200"
            >
                <MenuDialogItem
                    v-for="(subItem, index) in item.items"
                    :key="index"
                    :item="subItem"
                    class="px-4"
                    @close="emit('close')"
                />
            </ul>
        </Transition>
    </li>

    <button
        v-else
        type="button"
        class="group flex w-full items-center px-2 py-2 text-sm text-black hover:bg-gray"
        @click="callItemAction($event, item)"
    >
        {{ item.label }}
    </button>
</template>